<section class="terminal">
  <aside class="term-rail" [attr.aria-label]="lang.t('ai')">
    <button type="button" class="rail-deposit" (click)="openRail('deposit')">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4v12M7 11l5 5 5-5M5 20h14" /></svg>
      <span>{{ lang.t('poDeposit') }}</span>
    </button>
    <a routerLink="/markets" [attr.title]="lang.t('poMarkets')">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 16V8M10 16V4M16 16v-5M22 16H2" /></svg>
      <span>{{ lang.t('poMarkets') }}</span>
    </a>
    <button type="button" (click)="openRail('bot')">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v3M12 18v3M3 12h3M18 12h3M6 6l2 2M16 16l2 2M18 6l-2 2M8 16l-2 2" /></svg>
      <span>{{ lang.t('poBot') }}</span>
    </button>
    <button type="button" (click)="openRail('iq')">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 16l5-6 4 3 7-8M4 20h16" /></svg>
      <span>{{ lang.t('poIq') }}</span>
    </button>
    <button type="button" (click)="openRail('deposit')">
      <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="8" width="14" height="10" rx="2" /><path d="M9 8V6a3 3 0 0 1 6 0v2" /></svg>
      <span>{{ lang.t('poGet') }}</span>
    </button>
    <button type="button" (click)="openRail('help')">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 16l-2 4 5-2h7a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3z" /></svg>
      <span>{{ lang.t('poHelp') }}</span>
    </button>
    <a routerLink="/profile" [attr.title]="lang.t('poProfile')">
      <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="3" /><path d="M5 19c1.4-3 3.8-4.5 7-4.5S17.6 16 19 19" /></svg>
      <span>{{ lang.t('poProfile') }}</span>
    </a>
    <button type="button" (click)="openJupiter()">
      <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4" /><path d="M4 14c2.5-1 4.2-3.2 8-3.2S17.5 13 20 14" /></svg>
      <span>Jupiter</span>
    </button>
    <a [href]="trustHref" (click)="openTrust($event)">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3 5 6v6c0 4.2 2.8 7.2 7 9 4.2-1.8 7-4.8 7-9V6z" /></svg>
      <span>Trust Wallet</span>
    </a>
    @if (auth.user(); as user) {
      <a class="term-who" routerLink="/profile">{{ user.name }}</a>
    }
  </aside>

  <div class="term-workspace">
    <header class="term-bar">
      <strong>{{ selected() }}</strong>
      @if (active(); as quote) {
        <em [class.up]="quote.changePct >= 0" [class.down]="quote.changePct < 0">{{ price(quote.price, quote.precision) }} {{ pct(quote.changePct) }}</em>
      }
      @if (account.portfolio(); as book) {
        <span>{{ lang.t('poEquity') }} {{ money(book.equity) }}</span>
        <span [class.up]="book.unrealizedPnl >= 0" [class.down]="book.unrealizedPnl < 0">{{ lang.t('poPnl') }} {{ money(book.unrealizedPnl) }}</span>
      }
      <time>{{ clock() }}</time>
    </header>

    @if (failed(); as message) {
      <p class="term-alert" role="alert">{{ message }}</p>
    }

    <div class="term-grid">
      <section class="term-quotes" aria-label="Watchlist">
        <div class="term-tabs">
          <button type="button" [class.on]="listTab() === 'watch'" (click)="listTab.set('watch')">{{ lang.t('poWatch') }}</button>
          <button type="button" [class.on]="listTab() === 'movers'" (click)="listTab.set('movers')">{{ lang.t('poMovers') }}</button>
        </div>
        <ul>
          @for (quote of listed(); track quote.symbol) {
            <li [class.on]="quote.symbol === selected()">
              <button type="button" class="term-row" (click)="choose(quote.symbol)">
                <strong>{{ quote.symbol }}</strong>
                <span>{{ price(quote.price, quote.precision) }}</span>
                <em [class.up]="quote.changePct >= 0" [class.down]="quote.changePct < 0">{{ pct(quote.changePct) }}</em>
              </button>
              @if (quote.symbol === selected()) {
                <div class="term-ticket">
                  <button type="button" class="sell" (click)="openRail('deposit')">
                    <small>{{ lang.t('poSell') }}</small>
                    {{ price(bid(quote), quote.precision) }}
                  </button>
                  <div class="term-qty">
                    <button type="button" (click)="nudge(-1)" aria-label="Decrease">−</button>
                    <b>{{ orderQty() }}</b>
                    <button type="button" (click)="nudge(1)" aria-label="Increase">+</button>
                  </div>
                  <button type="button" class="buy" (click)="openRail('deposit')">
                    <small>{{ lang.t('poBuy') }}</small>
                    {{ price(ask(quote), quote.precision) }}
                  </button>
                </div>
              }
            </li>
          } @empty {
            <li class="term-empty">{{ lang.t('poEmpty') }}</li>
          }
        </ul>
      </section>

      <section class="term-chart" aria-label="Chart">
        <div class="term-ohlc">
          <strong>{{ selected() }}</strong>
          @if (ohlc(); as bar) {
            <span>O {{ price(bar.open, active()?.precision ?? 2) }}</span>
            <span>H {{ price(bar.high, active()?.precision ?? 2) }}</span>
            <span>L {{ price(bar.low, active()?.precision ?? 2) }}</span>
            <span>C {{ price(bar.close, active()?.precision ?? 2) }}</span>
          }
          @if (active(); as quote) {
            <em>{{ quote.name }}</em>
          }
        </div>
        @if (detail(); as market) {
          <app-candle-chart [candles]="market.candles" [precision]="market.quote.precision" />
        } @else {
          <p class="term-empty">{{ lang.t('poChart') }}</p>
        }
      </section>

      <section class="term-note">
        @if (active(); as quote) {
          <p class="kicker light">{{ lang.t('poSymbol') }}</p>
          <h2>{{ quote.symbol }}</h2>
          <p>{{ quote.name }}</p>
          <p>{{ lang.t('poDay') }} {{ pct(quote.changePct) }} · {{ lang.t('poLast') }} {{ price(quote.price, quote.precision) }}</p>
        }
      </section>

      <section class="term-book" aria-label="Positions and fills">
        <div class="term-tabs">
          <button type="button" [class.on]="pane() === 'positions'" (click)="pane.set('positions')">{{ lang.t('poPositions') }}</button>
          <button type="button" [class.on]="pane() === 'fills'" (click)="pane.set('fills')">{{ lang.t('poFills') }}</button>
        </div>
        @if (account.portfolio(); as book) {
          @if (pane() === 'positions') {
            @if (book.positions.length === 0) {
              <div class="term-blank">
                <svg viewBox="0 0 48 48" aria-hidden="true"><path d="M8 14h32v24H8z" /><path d="M16 14V10h16v4" /></svg>
                <strong>{{ lang.t('poNoPos') }}</strong>
                <span>{{ lang.t('poNoPosB') }}</span>
              </div>
            } @else {
              <div class="term-table">
                <table>
                  <thead>
                    <tr>
                      <th>{{ lang.t('poSymbol') }}</th>
                      <th class="num">{{ lang.t('poQty') }}</th>
                      <th class="num">{{ lang.t('poAvg') }}</th>
                      <th class="num">{{ lang.t('poLast') }}</th>
                      <th class="num">{{ lang.t('poPnl') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (position of book.positions; track position.symbol) {
                      <tr (click)="choose(position.symbol)">
                        <td><strong>{{ position.symbol }}</strong></td>
                        <td class="num">{{ qty(position.quantity) }}</td>
                        <td class="num">{{ price(position.avgPrice, position.symbol === 'EURUSD' ? 4 : 2) }}</td>
                        <td class="num">{{ price(position.last, position.symbol === 'EURUSD' ? 4 : 2) }}</td>
                        <td class="num" [class.up]="position.unrealizedPnl >= 0" [class.down]="position.unrealizedPnl < 0">{{ money(position.unrealizedPnl) }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          } @else if (book.orders.length === 0) {
            <div class="term-blank">
              <strong>{{ lang.t('poNoFills') }}</strong>
              <span>{{ lang.t('poNoFillsB') }}</span>
            </div>
          } @else {
            <div class="term-table">
              <table>
                <thead>
                  <tr>
                    <th>{{ lang.t('poSide') }}</th>
                    <th>{{ lang.t('poSymbol') }}</th>
                    <th class="num">{{ lang.t('poQty') }}</th>
                    <th class="num">{{ lang.t('poPrice') }}</th>
                    <th>{{ lang.t('poTime') }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (order of book.orders; track order.id) {
                    <tr (click)="choose(order.symbol)">
                      <td [class.up]="order.side === 'BUY'" [class.down]="order.side === 'SELL'">{{ order.side === 'BUY' ? lang.t('trBuy') : lang.t('trSell') }}</td>
                      <td><strong>{{ order.symbol }}</strong></td>
                      <td class="num">{{ qty(order.quantity) }}</td>
                      <td class="num">{{ price(order.fillPrice, order.symbol === 'EURUSD' ? 4 : 2) }}</td>
                      <td>{{ when(order.createdAt) }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        } @else if (!failed()) {
          <p class="term-empty">{{ lang.t('poOpeningAcc') }}</p>
        }
      </section>
    </div>
  </div>

  @if (rail() === 'deposit') {
    <div class="rail-pop" (click)="closeRail()">
      <div class="rail-card dark" (click)="$event.stopPropagation()" role="dialog" aria-labelledby="deposit-title">
        <button type="button" class="rail-x" (click)="closeRail()" [attr.aria-label]="lang.t('close')">×</button>
        <p class="kicker">{{ lang.t('poDeposit') }}</p>
        <h2 id="deposit-title">{{ lang.t('poPay') }}</h2>
        @if (depositStep() === 'account') {
          <p class="rail-lead">{{ lang.t('poConfirmed') }}</p>
          <div class="pay-drop">
            <button type="button" class="pay-bar" [class.open]="depositOpen() === 'account'" [attr.aria-expanded]="depositOpen() === 'account'" (click)="toggleDeposit('account')">
              {{ tier()?.name ?? lang.t('poChoose') }}
              <svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2.2 4.2 6 8l3.8-3.8" /></svg>
            </button>
            @if (depositOpen() === 'account') {
              <div class="pay-panel">
                <p>{{ lang.t('poAccounts') }}</p>
                @for (item of tiers(); track item.id) {
                  <button type="button" (click)="chooseTier(item.id)">
                    <strong>{{ item.name }}</strong>
                    <span>{{ lang.t('poMin') }} {{ item.label }}. {{ item.line }}</span>
                  </button>
                }
              </div>
            }
          </div>
          <button type="button" class="pay-next" [disabled]="!depositTier()" (click)="nextDeposit()">{{ lang.t('poNext') }}</button>
        } @else if (depositStep() === 'network') {
          @if (tier(); as chosen) {
            <div class="pay-pick">
              <p class="pay-pick-kicker">{{ lang.t('poGreat') }}</p>
              <h3>{{ chosen.name }}</h3>
              <p>{{ chosen.line }}</p>
              <p class="pay-pick-count"><strong>{{ depositTraders().toLocaleString('en-US') }}</strong> {{ lang.t('poPeople') }} {{ chosen.name }} {{ lang.t('poStarted') }}</p>
            </div>
            <div class="pay-point" aria-hidden="true">
              <svg viewBox="0 0 24 48"><path d="M12 4v32M5 28l7 12 7-12" /></svg>
            </div>
          }
          <div class="pay-drop">
            <button type="button" class="pay-bar" [class.open]="depositOpen() === 'network'" [attr.aria-expanded]="depositOpen() === 'network'" (click)="toggleDeposit('network')">
              {{ lang.t('poNetwork') }}
              <svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2.2 4.2 6 8l3.8-3.8" /></svg>
            </button>
            @if (depositOpen() === 'network') {
              <div class="pay-panel">
                <p>{{ lang.t('poNetworks') }}</p>
                @for (coin of coins; track coin.id) {
                  <button type="button" (click)="chooseCoin(coin.id)">
                    <strong>{{ coin.id }}</strong>
                    <span>{{ coin.name }}</span>
                  </button>
                }
              </div>
            }
          </div>
          <button type="button" class="pay-back" (click)="backDeposit()">{{ lang.t('poBack') }}</button>
        } @else if (deposit(); as coin) {
          <p class="rail-lead">{{ tier()?.name }} · {{ coin.name }}. {{ lang.t('poMin') }} {{ tier()?.label }}.</p>
          <div class="pay-box">
            <img [src]="coin.qr" [alt]="coin.name" width="220" height="220" />
            <p class="pay-address">{{ coin.address }}</p>
            <button type="button" class="pay-copy" (click)="copyAddress()">{{ copied() ? lang.t('poCopied') : lang.t('poCopy') }}</button>
          </div>
          <p class="rail-note">{{ lang.t('poSendOnly') }} {{ coin.id }} {{ lang.t('poOn') }} {{ coin.network }} {{ lang.t('poNetworkWord') }}</p>
          <p class="rail-note">{{ lang.t('poAfter') }}</p>
          <button type="button" class="pay-back" (click)="backDeposit()">{{ lang.t('poBack') }}</button>
          <div class="rail-links">
            <a class="touch-btn tg" href="https://t.me/CapiTradeAI_bot" target="_blank" rel="noopener">Telegram</a>
          </div>
        }
      </div>
    </div>
  }

  @if (rail() === 'iq') {
    <div class="rail-pop" (click)="closeRail()">
      <div class="iq-card" (click)="$event.stopPropagation()" role="dialog" aria-labelledby="iq-title">
        <button type="button" class="rail-x dark" (click)="closeRail()" [attr.aria-label]="lang.t('close')">×</button>
        @if (active(); as quote) {
          <div class="iq-head">
            <strong id="iq-title">{{ quote.symbol }}</strong>
            <span class="iq-tone" [attr.data-tone]="iq().tone">{{ iq().tone }}</span>
          </div>
          <div class="iq-price-row">
            <div>
              <p class="iq-label">{{ lang.t('poLastPrice') }}</p>
              <p class="iq-price">{{ price(quote.price, quote.precision) }}</p>
              <p class="iq-score">RSI {{ fixed(iq().rsi, 1) }} · {{ iq().tone }}</p>
            </div>
            <svg class="iq-spark" viewBox="0 0 220 64" aria-hidden="true">
              <polyline [attr.points]="sparkPoints()" />
            </svg>
          </div>
          <div class="iq-tabs">
            <button type="button" [class.on]="iqTab() === 'stats'" (click)="iqTab.set('stats')">{{ lang.t('poStats') }}</button>
            <button type="button" [class.on]="iqTab() === 'analysis'" (click)="iqTab.set('analysis')">{{ lang.t('poAnalysis') }}</button>
            <button type="button" [class.on]="iqTab() === 'indicators'" (click)="iqTab.set('indicators')">{{ lang.t('poIndicators') }}</button>
          </div>
          @if (iqTab() === 'stats') {
            <div class="iq-range">
              <span>{{ lang.t('trSession') }}</span>
              <strong>{{ session(iq().low, quote.precision) }} – {{ session(iq().high, quote.precision) }}</strong>
              <i [style.width.%]="iq().spot * 100"></i>
            </div>
            <p class="iq-copy">{{ iq().stats }}</p>
          }
          @if (iqTab() === 'analysis') {
            <p class="iq-copy">{{ iq().analysis }}</p>
          }
          @if (iqTab() === 'indicators') {
            <ul class="iq-list">
              @for (row of iq().rows; track row.name) {
                <li>
                  <span>{{ row.name }}<small>{{ row.note }}</small></span>
                  <strong>{{ row.value }}</strong>
                </li>
              }
            </ul>
          }
          <p class="iq-fine">{{ lang.t('poTape') }}</p>
        }
      </div>
    </div>
  }

  @if (rail() === 'bot') {
    <div class="rail-pop" (click)="closeRail()">
      <div class="rail-card dark bot-card" (click)="$event.stopPropagation()" role="dialog" aria-labelledby="bot-title">
        <button type="button" class="rail-x" (click)="closeRail()" [attr.aria-label]="lang.t('close')">×</button>
        <img src="/ai-trading-bot.jpg" [alt]="lang.t('poBotAlt')" />
        <h2 id="bot-title">{{ lang.t('poBotTitle') }}</h2>
        <p class="rail-lead">{{ lang.t('poBotP') }}</p>
        <p class="bot-access">{{ lang.t('poBotAccess') }}</p>
        <button type="button" class="pay-next" (click)="openRail('deposit')">{{ lang.t('poDeposit') }}</button>
      </div>
    </div>
  }

  @if (rail() === 'help') {
    <div class="rail-pop" (click)="closeRail()">
      <div class="help-card" (click)="$event.stopPropagation()" role="dialog" aria-labelledby="help-title">
        <button type="button" class="rail-x dark" (click)="closeRail()" [attr.aria-label]="lang.t('close')">×</button>
        <div class="help-mark" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M6 16l-2 4 5-2h7a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3z" /></svg>
        </div>
        <h2 id="help-title">{{ lang.t('poHelpTitle') }}</h2>
        <p>{{ lang.t('poHelpP') }}</p>
        <div class="help-starts">
          <button type="button" (click)="askDesk(lang.t('poExplain'))">{{ lang.t('poExplain') }}</button>
          <button type="button" (click)="askDesk(lang.t('poReadM'))">{{ lang.t('poReadM') }}</button>
          <button type="button" (click)="askDesk(lang.t('poOpenMine'))">{{ lang.t('poOpenMine') }}</button>
        </div>
      </div>
    </div>
  }

  @if (rail() === 'trust') {
    <div class="rail-pop" (click)="closeRail()">
      <div class="rail-card dark" (click)="$event.stopPropagation()" role="dialog" aria-label="Trust Wallet">
        <button type="button" class="rail-x" (click)="closeRail()" [attr.aria-label]="lang.t('close')">×</button>
        <p class="kicker">Trust Wallet</p>
        <h2>Trust Wallet</h2>
        @switch (trustState()) {
          @case ('opening') {
            <p class="rail-lead">{{ lang.t('trustOpening') }}</p>
          }
          @case ('connected') {
            <p class="rail-lead">{{ lang.t('trustConnected') }}</p>
            <p class="pay-address">{{ trustAccount() }}</p>
          }
          @case ('closed') {
            <p class="rail-lead">{{ lang.t('trustClosed') }}</p>
            <a class="pay-next trust-get" [href]="trustHref">{{ lang.t('trustRetry') }}</a>
          }
          @case ('missing') {
            <p class="rail-lead">{{ lang.t('trustMissing') }}</p>
            <a class="pay-next trust-get" href="https://trustwallet.com/download" target="_blank" rel="noopener">{{ lang.t('trustDownload') }}</a>
          }
        }
      </div>
    </div>
  }

  @if (rail() === 'jupiter') {
    <div class="rail-pop" (click)="closeRail()">
      <div class="jupiter-card" (click)="$event.stopPropagation()" role="dialog" aria-label="Jupiter">
        <button type="button" class="rail-x" (click)="closeRail()" [attr.aria-label]="lang.t('close')">×</button>
        <div id="jupiter-plugin" class="jupiter-mount"></div>
      </div>
    </div>
  }
</section>
